import React from 'react';
import Base from '../core/Base';
const  UserDashboard = () =>{
    return (
        <Base title="User Dashboard ">
        <h1>this is User dashboard </h1>
        </Base>
    );
};

export default UserDashboard;